import { createRoot } from "react-dom/client";

import { App } from "./app";
import { createAppServices } from "./app-services";
import { setUpPage } from "./page-setup";
import { createRouter } from "./router";

async function main() {
  await setUpPage({ sentry: true });

  const { app } = createAppServices();

  const rootElement = document.getElementById("root");

  if (!rootElement) {
    throw new Error("Root element not found");
  }

  createRoot(rootElement).render(<App router={createRouter(app)} />);
}

void main();
